import * as React from "react";
import styled from "styled-components";

const Wrapper = styled.div<{ margin?: string }>`
  width: 100%;
  margin-bottom: ${({ margin }) => (margin ? margin : "20px")};
`;

const Label = styled.label`
  display: flex;
  margin-bottom: 5px;

  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 22px;

  letter-spacing: -0.01em;

  color: #1e2029;
`;

export function RadioInput({
                               wrapperStyle,
                               margin,
                               inputLabel,
                               error,
                               value,
                               onChange,
                               children,
                               ...rest
                           }: any) {
    const onClick = (name) => () => {
        onChange({ currentTarget: { value: name } });
    };

    const childs = React.Children.map(children, (c) =>
        React.cloneElement(c, { selected: c.props.name == value, onClick: onClick })
    );

    return (
        <Wrapper margin={margin} style={wrapperStyle}>
            {inputLabel && <Label htmlFor={"input-" + rest.name}>{inputLabel}</Label>}
            <div style={{ display: "flex" }}>{childs}</div>
        </Wrapper>
    );
}
